import React from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { Card, AuthComponent, Chart, Button } from '../components';
import { accountConstants, routes, fetchTypes, apiRoutes, contentTypes } from '../constants';
import { AuthDelegate, ResourceUtils, ReportCSV } from '../utils';
import { ResourceActions } from '../actions';
import store from '../store';

const { statuses } = accountConstants;

class SampleTrendingPage extends AuthComponent {

    userIsAuthorized(user) {
        return AuthDelegate.userHasApprovalState(statuses.APPROVED)(user);
    }

    userDidAuthorize() {
        this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.REPORT_DATA, {
            reportId: this.props.params.reportId, method: 'Chart'
        }));
    }

    componentWillRejectUser() {
        browserHistory.push(routes.LOGIN);
    }

    exportCSV() {
        store.dispatch(ResourceActions.resourceFetch(fetchTypes.REPORT_DATA, {
            reportId: this.props.params.reportId, method: 'Csv'
        }, {
            onSuccess: (payload) => {
                let csv = new ReportCSV(payload);
                csv.save();
            }
        }));
    }

    exportPDF() {
        const url = apiRoutes.REPORT_PDF_BASE + this.props.params.reportId;
        const token = store.getState().activeUser['access_token'];

        ResourceUtils.fetchAsBlob(url, {
            contentType: contentTypes.APPLICATION_PDF,
            token: token
        })
        .then(blob => {
            ResourceUtils.downloadBlob(blob, {
                target: '_blank',
                fileName: `report-${this.props.params.reportId}`
            });
        });
    }

    renderChart(chartData, i) {
        return (
            <div key={i} className="col-sm-6">
                <Chart id="testChart" data={chartData} />
            </div>
        )
    }

    authRender () {
        return (
            <div className="container" id="container-sample-trending">
                <div className="row">
                    <div className="col-sm-12">
                        <Card>
                            <div className="card-title-area">
                                <Button onClick={() => browserHistory.goBack()} className="back-button pull-left"><span className="icon-arrow-left"></span> Back</Button>
                                <Button onClick={() => this.exportCSV()} className="pull-right"><span className="icon-report"></span> Export CSV</Button>
                                <Button onClick={() => this.exportPDF()} className="pull-right"><span className="icon-report"></span> Export PDF</Button>
                                <strong className="trending-title">Data Trending for Report {this.props.params.reportId}</strong>
                                <div className="clearfix"></div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    { this.props.reportData.chartAdapter.charts.map((chartData, i) => this.renderChart(chartData, i)) }
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser,
        reportData: state.reportData
    }
}

export default connect(select)(SampleTrendingPage);



// WEBPACK FOOTER //
// ./web-app/containers/sample-trending.jsx